import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';

export const useConfigurePage = () => {
  const history = useHistory();
  const selectedDealer = useSelector(selectDealerSelected);
  const hasSelectedDealer = hasDealerContext(selectedDealer);

  const goToContent = useCallback(() => {
    history.push('/content', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Content Management', isActive: true },
      ],
    });
  }, [history]);

  const goToCalendarConfiguration = useCallback(() => {
    history.push('/configure-calendar', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Channel settings', isActive: true },
      ],
    });
  }, [history]);

  const goToSegmentsConfiguration = useCallback(() => {
    history.push('/configure-segments', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Dealer segment settings', isActive: true },
      ],
    });
  }, [history]);

  const goToTemplateValuePreferences = useCallback(() => {
    history.push('/configure-template-value', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Template Value Preferences', isActive: true },
      ],
    });
  }, [history]);

  const goToTemplateMessageTypeFocus = useCallback(() => {
    history.push('/configure-template-message-type', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Segment Message Type Focus', isActive: true },
      ],
    });
  }, [history]);

  const goToStaticContentValueMessages = useCallback(() => {
    history.push('/configure-static-content', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Static Content - Value Messages', isActive: true },
      ],
    });
  }, [history]);

  const goToNurturingJourneySettings = useCallback(() => {
    history.push('/configure-nurturing-journey', {
      breadcrumbsList: [
        { label: 'Configure', link: '/configure', isActive: false },
        { label: 'Nurturing Journey Settings', isActive: true },
      ],
    });
  }, [history]);

  return {
    hasSelectedDealer,
    goToContent,
    goToCalendarConfiguration,
    goToSegmentsConfiguration,
    goToTemplateValuePreferences,
    goToTemplateMessageTypeFocus,
    goToStaticContentValueMessages,
    goToNurturingJourneySettings,
  };
};
